import React from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'packages/eid-ui'

const maxCharacters = 80

const tooltipStyles = {
    boxShadow: '0 2px 16px 0 rgba(0, 0, 0, 0.11)',
    padding: '8px',
    maxWidth: '500px',
    backgroundColor: '#0057A0',
}

const StyledBox = styled(Box)(() => styles.textStyles)

export const TextFormatter = ({ attribute, item }) => {
    const { t } = useTranslation()

    const getValue = (ci, attribute) => {
        let value = ci[attribute.name]
        if (typeof value === 'boolean') {
            return value ? t('Yes') : t('No')
        } else {
            return ci[attribute.name] ?? ''
        }
    }

    const value = getValue(item, attribute)
    const cellContent = (
        <StyledBox>
            {value.length > maxCharacters
                ? `${value.substring(0, maxCharacters)}...`
                : value}
        </StyledBox>
    )

    const wrappedCellContent =
        value.length > maxCharacters ? (
            <Tooltip
                title={value}
                color="#5D6870"
                fontColor="#ffffff"
                enterDelay={500}
                enterNextDelay={500}
                disableInteractive={false}
                tooltipStyles={tooltipStyles}
                placement="bottom-start"
                arrow={false}
            >
                {cellContent}
            </Tooltip>
        ) : (
            cellContent
        )

    return <>{wrappedCellContent}</>
}

export const colors = {
    primary: '#0057A0',
    grey: '#7d7c7c',
}

export const styles = {
    tableHeaderContent: {
        display: 'inline-flex',
        alignItems: 'center',
        flexDirection: 'inherit',
        justifyContent: 'flex-start',
        marginLeft: '-3.6rem',
    },
    green: {
        color: '#4caf50',
    },
    black: {
        color: '#424242',
    },
    blue: {
        color: '#0057A0',
    },
    boldBlue: {
        color: '#0057A0',
        fontWeight: 'bold',
    },
    underline: {
        textDecoration: 'underline',
    },
    greyColor: {
        color: 'grey !important',
    },
    table: {
        backgroundColor: '#ffffff',
        '& tr:hover': {
            backgroundColor: '#f7f8fa',
        },
    },
    tableRow: {
        border: 'solid 1px #efeff1',
    },
    highlightedRow: {
        border: 'solid 1px #0057A0',
        boxShadow: '4px 4px 15px 0 rgba(48, 127, 193, 0.15)',
    },
    tableCell: {
        fontSize: '13px',
        borderBottom: '0',
        '&:first-of-type': {
            padding: '15px 25px',
        },
    },
    tableCellHighlighted: {
        borderTop: 'solid 1px #0057A0',
        padding: '15px 10px',
        fontSize: '13px',
        borderBottom: '0',
        '&:first-of-type': {
            padding: '15px 25px',
        },
    },
    hilightFont: {
        fontSize: '15px',
    },
    rowSelect: {
        borderBottom: '1px solid grey',
        borderRadius: '0',
    },
    tablePagination: {
        color: 'grey !important',
    },
    bigAvatar: {
        marginLeft: '4px',
        width: 50,
        height: 50,
    },
    loadButton: {
        color: '#0057A0',
        width: '100%',
        textTransform: 'inherit',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    iconRegular: {
        width: '20px',
        height: '20px',
        objectFit: 'contain',
        marginRight: '7px',
    },
    iconSpacing: {
        marginRight: '7px',
    },
    textStyles: {
        display: 'block',
        wordBreak: 'break-word',
        wordWrap: 'break-word',
        maxHeight: '200px',
        minWidth: '12rem',
        overflow: 'auto',
    },
}

export const renderIcon = (heading, sort, sortBy, sortOrder) => {
    // ...function implementation
}
